export const routes = [
  {
    path: '',
    name: 'WebinarList',
    component: () => import('./pages/WebinarList.vue'),
    meta: {
      title: 'Вебинары',
      authorize: [],
    },
  },
  {
    path: '/:id',
    name: 'WebinarView',
    component: () => import('./pages/WebinarView.vue'),
    meta: {
      title: 'Просмотр вебинара',
      authorize: [],
      breadcrumbs: {
        parent: 'WebinarList',
      },
    },
  },
  {
    path: '/create',
    name: 'WebinarCreate',
    component: () => import('./pages/WebinarCreate.vue'),
    meta: {
      title: 'Добавить вебинар',
      authorize: [],
      update: false,
    },
  },
  {
    path: '/update/:id',
    name: 'WebinarUpdate',
    component: () => import('./pages/WebinarCreate.vue'),
    meta: {
      title: 'Изменить вебинар',
      authorize: [],
      update: true,
    },
  },
];

export default routes;
